<div class="toast-container">
  <mat-card 
    *ngFor="let toast of toasts" 
    class="toast"
    [ngClass]="'toast-' + toast.type"
    (click)="removeToast(toast.id)"
  >
    <mat-card-content>
      <div class="toast-content">
        <mat-icon class="toast-icon">{{ getIconName(toast.type) }}</mat-icon>
        <div class="toast-text">
          <div class="toast-title">{{ toast.title }}</div>
          <div class="toast-message">{{ toast.message }}</div>
        </div>
        <button mat-icon-button class="toast-close" (click)="removeToast(toast.id)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
